import styled from 'styled-components';
export var Raised = styled.div(function (props) { return ({
    backgroundColor: props.layer === 2 ? '#FFF' : '#FBFBFB',
    boxShadow: '0px 0px 2px rgba(0, 0, 0, 0.15)',
}); });
